var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 27,
  viewBox: "0 0 23 27"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5 26.342c3.63-3.107 4.943-4.288 6.458-5.886 3.087-3.258 4.542-6.117 4.542-9.414C22.5 5.225 17.579.5 11.5.5S.5 5.225.5 11.042c0 3.297 1.455 6.156 4.542 9.414 1.515 1.598 2.828 2.779 6.458 5.886z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 10.5,
  r: 3
}))));
export default SvgLocation;